module.exports = __webpack_public_path__ + "static/image/logo-family/logo_ceo@2x.png?ad5839eb";